/**
 * Field Operations Container Module Routes
 *
 * Redirects `/field-operations` to `/toolbox-talks`.
 */

import type { RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
    {
        path: '/field-operations',
        redirect: '/toolbox-talks',
        meta: {
            moduleKey: 'toolbox_talks',
        },
    },
]

export default routes
